import store from '@shared/store/index';

export function callScannerInnerPage(compareCoin){
  store.dispatch('Scanner/initScanner', { initCoin: compareCoin });
}